<template>
  <action-dispatcher
    class="view-podcast-episodes container text-light py-4"
    action="podcasts/getPodcasts"
  >
    <action-dispatcher
      action="podcasts/getPodcastEpisodes"
      :parameters="$route.params.id"
    >
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <router-link class="small text-secondary" :to="{ name: 'podcasts' }">
            <i class="fas fa-chevron-left" /> Podcasts
          </router-link>

          <div class="row align-items-center my-3">
            <div class="col-4">
              <img :src="podcast.photo" class="img-fluid" />
            </div>
            <div class="col-8">
              <h5 class="mb-2">{{ podcast.name }}</h5>
              <small>{{ podcastEpisodes.length }} episódios</small>
              <div class="description mt-2" v-html="podcast.description" />
            </div>
          </div>

          <iframe
            v-for="episode in podcastEpisodes"
            :key="episode.id"
            class="w-100 border-0 my-3"
            :src="src(episode)"
            :height="iframeHeight(episode)"
          />
        </div>
      </div>
    </action-dispatcher>
  </action-dispatcher>
</template>

<script>
import { mapState } from "vuex";
import get from "lodash/get";

export default {
  computed: {
    ...mapState("podcasts", ["podcasts", "podcastEpisodes"]),
    podcast() {
      return this.podcasts.find(pod => pod.id == this.$route.params.id) || {};
    }
  },
  methods: {
    src(audio) {
      if (audio.link.indexOf("player") > 0) {
        return audio.link;
      }
      return `https://w.soundcloud.com/player/?url=${audio.link}`;
    },
    iframeHeight(audio) {
      if (audio.link.indexOf("playlists") > 0) {
        return 450;
      }
      return 170;
    }
  }
};
</script>

<style lang="scss" scoped>
.view-podcast-episodes {
  .description {
    font-size: 14px;
    color: #d7d7d7;
  }
}
</style>
